import ICON_DE from '@/assets/images/flags/de.svg';
import ICON_EL from '@/assets/images/flags/el.svg';
import ICON_EN_GB from '@/assets/images/flags/en_GB.svg';
import ICON_EN_US from '@/assets/images/flags/en_US.svg';
import ICON_ES from '@/assets/images/flags/es.svg';
import ICON_FR from '@/assets/images/flags/fr.svg';
import ICON_IT from '@/assets/images/flags/it.svg';
import ICON_NL from '@/assets/images/flags/nl.svg';
import ICON_PT from '@/assets/images/flags/pt.svg';
import ICON_PT_BR from '@/assets/images/flags/pt_BR.svg';
import ICON_RU from '@/assets/images/flags/ru.svg';
import ICON_ZH from '@/assets/images/flags/zh.svg';
import type { LocaleCode } from './types';

export const FLAG_BY_LOCALE: Record<LocaleCode, string> = {
  'en-GB': ICON_EN_GB,
  'en-US': ICON_EN_US,
  'nl-NL': ICON_NL,
  'de-DE': ICON_DE,
  'fr-FR': ICON_FR,
  'it-IT': ICON_IT,
  'es-ES': ICON_ES,
  'pt-PT': ICON_PT,
  'pt-BR': ICON_PT_BR,
  'el-GR': ICON_EL,
  'ru-RU': ICON_RU,
  'zh-CN': ICON_ZH,
};
